const Style = {

  base: 'relative block text-[0.76rem] font-semibold text-[#374151] mb-1 tracking-[0.01em]',
  required: `after:text-red-500 after:ml-1 after:font-semibold after:content-['*']`

}

export default Style;
